import { Component, OnInit, Input } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { CommonFunctionsService } from '../common-functions.service';
import { RestApiService } from '../rest-api.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-productunit',
  templateUrl: './productunit.page.html',
  styleUrls: ['./productunit.page.scss'],
})
export class ProductunitPage implements OnInit {
  meta: any = [];
  unit_sizes: any = [];
  @Input() code: string;
  isLoading: boolean = false;
  isProcessing: boolean = false;
  dataForm: FormGroup;
  constructor(public modalController: ModalController, public alertController: AlertController, public restApi: RestApiService, public commonFunctions: CommonFunctionsService) { }

  ngOnInit() {
    this.dataForm = new FormGroup({
      'unit_size_id': new FormControl(null, [Validators.required]),
      'amount': new FormControl(null, [Validators.required]),
      'tax': new FormControl(0, []),
      'discount_type': new FormControl('fixed', []),
      'discount_amount': new FormControl(0, []),
      'status': new FormControl(true, [Validators.required]),
      'code': new FormControl(null, [])
    });
    if (this.code != '') {
      this.getDetail();
    }
    this.getUnitSizes();
  }

  closeDialog() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  submitForm() {
    if (this.dataForm.value.code == '' || !this.dataForm.value.code) {
      this.add();
    } else {
      this.update();
    }
  }

  update() {
    this.isLoading = true;
    var formData = new FormData();
    for (let key in this.dataForm.value) {
      let value = this.dataForm.value[key];
      if (key == 'status') {
        if (value == true) {
          value = 1;
        } else {
          value = 0;
        }
      }
      formData.append(key, value);
    }
    this.restApi.put('shop_product_unit_size/' + this.dataForm.value.code, formData).subscribe((data: any) => {
      this.isLoading = false;
      if (data['code'] == 200) {
        this.getDetail();
        this.dataForm.reset();
      }
      this.commonFunctions.presentAlertConfirm('Information', data['message']);
    }, (error: any) => {
      this.isLoading = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  add() {
    this.isLoading = true;
    var formData = new FormData();
    for (let key in this.dataForm.value) {
      let value = this.dataForm.value[key];
      if (key == 'status') {
        if (value == true) {
          value = 1;
        } else {
          value = 0;
        }
      }
      formData.append(key, value);
    }
    this.restApi.post('shop_product_unit_size/' + this.code, formData).subscribe((data: any) => {
      this.isLoading = false;
      if (data['code'] == 200) {
        this.getDetail();
        this.dataForm.reset();
      }
      this.commonFunctions.presentAlertConfirm('Information', data['message']);
    }, (error: any) => {
      this.isLoading = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  loadDetail(code) {
    (this.meta).forEach(element => {
      if (element.code == code) {
        let active = false;
        if (element.status == 1) {
          active = true;
        }
        this.dataForm.patchValue({
          unit_size_id: element.unit_size_id,
          amount: element.amount,
          tax: element.tax,
          discount_type: element.discount_type,
          discount_amount: element.discount_amount,
          status: active,
          code: element.code
        });
        return false;
      }
    });
  }

  getDetail() {
    this.isProcessing = true;
    this.restApi.get('shop_product_unit_size/' + this.code).subscribe((data: any) => {
      this.isProcessing = false;
      if (data['code'] == 200) {
        this.meta = data.data;
      }
    }, (error: any) => {
      this.isProcessing = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  getUnitSizes() {
    this.isProcessing = true;
    this.restApi.get('shop_product_unit_size_dropdown/' + this.code).subscribe((data: any) => {
      this.isProcessing = false;
      if (data['code'] == 200) {
        this.unit_sizes = data.data;
      }
    }, (error: any) => {
      this.isProcessing = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }
}
